import { BadgeCheck, MapPin, Timer, ShieldCheck } from "lucide-react";
import { MaskedLines, FadeUp } from "./Reveal";
import { BookButton, CallButton, WhatsAppButton } from "./CTA";
import { SITE } from "../config/site";

const TRUST = [
  { icon: BadgeCheck, label: "25+ Years Experience" },
  { icon: MapPin, label: "Delhi NCR" },
  { icon: Timer, label: "Same-Day Service" },
  { icon: ShieldCheck, label: "100% Solution Guaranteed*" },
];

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="py-24 lg:py-36 bg-charcoal text-ivory grain relative overflow-hidden">
    <div className="max-w-5xl mx-auto px-5 lg:px-10 relative text-center">
      <FadeUp>
        <span className="text-[11px] tracking-[0.35em] uppercase font-bold text-gold">{SITE.companyName} · Free Inspection · Same-Day Slots</span>
      </FadeUp>
      <h2 data-testid="final-cta-headline" className="font-display font-semibold tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl mt-6">
        <MaskedLines lines={[<>Ready to get your pest problem</>, <span className="italic text-gold">under control?</span>]} />
      </h2>
      <FadeUp delay={0.3} className="mt-7 max-w-xl mx-auto">
        <p className="text-ivory/65 leading-relaxed">
          Book your FREE inspection today. Same-day service available across Delhi, Gurugram and Noida.
        </p>
      </FadeUp>
      <FadeUp delay={0.45} className="mt-10 flex flex-col sm:flex-row justify-center gap-3">
        <BookButton testid="final-book-btn" light />
        <CallButton testid="final-call-btn" dark />
        <WhatsAppButton testid="final-whatsapp-btn" dark />
      </FadeUp>
      <FadeUp delay={0.55} className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-x-10 gap-y-2.5 text-sm">
        <a data-testid="final-primary-phone" href={SITE.phoneHref} className="text-ivory/85 hover:text-gold transition-colors">
          Primary Contact: <span className="font-bold text-ivory">{SITE.phoneDisplay}</span>
        </a>
        <a data-testid="final-secondary-phone" href={SITE.secondaryPhoneHref} className="text-ivory/85 hover:text-gold transition-colors">
          Additional Contact: <span className="font-bold text-ivory">{SITE.secondaryPhoneDisplay}</span>
        </a>
        <a data-testid="final-whatsapp-number" href={SITE.whatsappHref} target="_blank" rel="noopener noreferrer" className="text-ivory/85 hover:text-gold transition-colors">
          WhatsApp: <span className="font-bold text-ivory">{SITE.whatsappDisplay}</span>
        </a>
      </FadeUp>
      <FadeUp delay={0.65} className="mt-12 flex flex-wrap justify-center gap-x-8 gap-y-3 border-t border-ivory/10 pt-8">
        {TRUST.map((t) => (
          <div key={t.label} className="flex items-center gap-2">
            <t.icon className="h-4 w-4 text-gold" strokeWidth={1.75} />
            <span className="text-[12px] font-semibold text-ivory/70">{t.label}</span>
          </div>
        ))}
      </FadeUp>
    </div>
  </section>
);
